import { useEffect, useState } from "react";
import SearchBar from "./components/SearchBar";
import Weather from "./components/Weather";
import axios from "axios";


function App() {

  const [location, setLocation] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("");
  const [searched, setSearched] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const key = `8facc165a291ca9e355c1d0781951d6d`
  const url = `https://api.openweathermap.org/data/2.5/weather?q=${location}&units=metric&appid=${key}`
  const userLocationUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=${key}`


  const searchLocation = async (event) => {
    try {
      setLoading(true)
      if (event.key === "Enter") {
        const response = await axios.get(url)
        setData(response)
        setBackgroundColor(getBackgroundColor(data?.data.main.temp))
        setLocation("")
        setSearched(true);
      }
    } catch (error) {
      setLoading(true)
      setBackgroundColor("");
      setData(null)
      setLocation("")
      setSearched(true);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const updateBackgroundColor = () => {
      if (data) {
        setBackgroundColor(getBackgroundColor(data));
      }
    };
    updateBackgroundColor();
  }, [data]);


  // const fetchUserLocationWeather = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get(userLocationUrl);
  //     setData(response);
  //     setBackgroundColor(getBackgroundColor(response.data));
  //     setSearched(true);
  //   } catch (error) {
  //     setLoading(true);
  //     console.log(error);
  //     setData(null);
  //     setBackgroundColor("");
  //     setSearched(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    const fetchUserWeather = async () => {
      try {
        setLoading(true);
        if (latitude !== null && longitude !== null) {
          const response = await axios.get(userLocationUrl);
          setData(response);
          setBackgroundColor(getBackgroundColor(response.data));
          setSearched(true);
        } else {
          console.error("Latitude and longitude are not available yet.");
        }
      } catch (error) {
        setLoading(true);
        console.log(error);
        setData(null);
        setBackgroundColor("");
        setSearched(true);
      } finally {
        setLoading(false);
      }
    };

    fetchUserWeather();
  }, [latitude, longitude, userLocationUrl]);

  const getUserLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setLatitude(latitude);
        setLongitude(longitude);
      },
      (error) => {
        console.error("Error getting user location:", error);
      }
    );
  };

  const getBackgroundColor = () => {
    try {
      const temp = data?.data.main?.temp;
      if (temp < 22) {
        return "bg-sky-400";
      } else if (temp >= 22 && temp <= 30) {
        return "bg-emerald-400";
      } else {
        return "bg-yellow-400";
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className={`${backgroundColor} h-screen transition-colors duration-1000 ease-in-out`}>
      <div className="mx-8">

        <SearchBar
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          search={searchLocation}
          onClick={getUserLocation}
        />

        <div className="">
          <Weather
            data={data}
            loading={loading}
            searched={searched}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
